export const compareColumns = (columnsA: string[], columnsB: string[]) => {
  return (
    columnsA.length === columnsB.length &&
    columnsA.every(a => columnsB.includes(a))
  );
};
